import { useState } from "react";
import { auth } from "../../../config/firebase";
import { useNavigate } from "react-router-dom";
import { signInWithEmailAndPassword } from "firebase/auth";
import "./Login.css";


function Login() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const navigate = useNavigate();

  const handleLogin = async () => {
    try {
      await signInWithEmailAndPassword(auth, username, password);
      // User signed in successfully
      // Navigate to dashboard or set state indicating user is authenticated
      navigate("/dashboard");
    } catch (error) {
      alert("Invalid Credentials");
      console.error("Error during login:", error);
    }
  };

  return (
    <div className="loginContainer">
      <img src="/yavola_logo.png" alt="Yavola Logo" className="login-logo" />

      <input
        type="text"
        value={username}
        onChange={(e) => setUsername(e.target.value)}
        placeholder="Username"
      />
      <input
        type="password"
        value={password}
        onChange={(e) => setPassword(e.target.value)}
        placeholder="Password"
      />
      <button onClick={handleLogin}>Login</button>
    </div>
  );
}

export default Login;
